import { render } from "./ColorBlock.vue.js?vue&type=template&id=4bff3b9e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ColorBlock.vue?vue&type=template&id=4bff3b9e"
import script from "./ColorBlock.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ColorBlock.vue?vue&type=script&lang=js"
export * from "./ColorBlock.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ColorBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/themes/ColorBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bff3b9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bff3b9e', __exports__)) {
    api.reload('4bff3b9e', __exports__)
  }
  
  module.hot.accept("./ColorBlock.vue.js?vue&type=template&id=4bff3b9e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ColorBlock.vue?vue&type=template&id=4bff3b9e", () => {
    api.rerender('4bff3b9e', render)
  })

}


export default __exports__